'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getExperiencePath = function getExperiencePath(path) {
  var match = void 0;
  match = path.match(/^\/(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/home',
      query: {
        // city: 'Bangkok',
      }
    };
  }
  match = path.match(/^\/logout?$/i);
  if (match) {
    return {
      pathname: '/logout',
      query: {}
    };
  }
  match = path.match(/^\/to\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/city',
      query: {
        city: match[1]
      }
    };
  }
  match = path.match(/^\/other-cities\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/search',
      query: {
        city: 'Other',
        type: 'real-local-experience'
      }
    };
  }
  match = path.match(/^\/to\/([\w-% ]+)\/([\w-%]+)\/?(\?.*)?$/i);
  if (match) {
    var internalPath = {
      pathname: '/search',
      query: {
        city: match[1],
        type: match[2]
      }
    };
    if (match[3]) {
      internalPath.query.focus = match[3].split('?focus=')[1];
    }
    return internalPath;
  }
  match = path.match(/^\/trip\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/trip-detail',
      query: {
        slug: match[1]
      }
    };
  }
  match = path.match(/^\/local-expert\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/local-expert-detail',
      query: {
        slug: match[1]
      }
    };
  }
  match = path.match(/^\/article\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        slug: 'all-article'
      }
    };
  }
  match = path.match(/^\/article\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        slug: match[1]
      }
    };
  }
  match = path.match(/^\/dusit\/?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        slug: 'dusit-main'
      }
    };
  }
  match = path.match(/^\/dusit\/city\/([\w-% ]+)\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/article/article',
      query: {
        slug: 'dusit-city-' + match[1]
      }
    };
  }
  match = path.match(/^\/dashboard\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/dashboard'
    };
  }
  match = path.match(/^\/dashboard\/listing\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/dashboard/listing'
    };
  }
  match = path.match(/^\/dashboard\/wallet\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/dashboard/wallet'
    };
  }
  match = path.match(/^\/dashboard\/booking\/?(\?.*)?$/i);
  if (match) {
    return {
      pathname: '/dashboard/booking'
    };
  }
  return false;
};

var _Link = function _Link(props) {
  var linkData = getExperiencePath(props.to);
  if (linkData && (!props.locale || props.locale === 'en')) {
    var queryString = '';
    if (props.query) {
      var keys = (0, _keys2.default)(props.query);
      queryString = keys.map(function (key) {
        return key + '=' + props.query[key];
      }).reduce(function (s, q, i) {
        if (i !== 0) return s + '&' + q;
        return s + q;
      }, '?');
    }
    return _react2.default.createElement(
      'a',
      (0, _extends3.default)({}, props, { className: props.className, href: props.to + queryString }),
      props.children
    );
  }
  return (
    // <a href={props.to} {...props} className={props.className}>
    //   {props.children}
    // </a>
    _react2.default.createElement(
      _reactRouter.Link,
      (0, _extends3.default)({}, props, { to: props.to || '/' }),
      props.children
    )
  );
};

_Link.displayName = 'Link';

_Link.propTypes = {
  children: _react.PropTypes.any,
  className: _react.PropTypes.string,
  to: _react.PropTypes.string,
  query: _react.PropTypes.object,
  locale: _react.PropTypes.string
};

_Link.defaultProps = {
  to: '/'
  // target: '_self',
};

exports.default = _Link;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/Link.js
// module id = 20
// module chunks = 47